import React from "react";
import { salesPurchaseStatusoptions } from "../helper-components/data";
import FilterRadioButtons from "../forms/filter-radio-buttons";

const SalesPurchaseFilter = ({ setFilterData, filterData, setCurrentPage }) => {
  const handleOrderStatusChange = (e) => {
    setFilterData({
      ...filterData,
      orderStatus: e.target.value,
    });
    setCurrentPage(1);
  };

  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "13rem",                
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0px 1px 3px 0px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-2 px-2  bg-[var(--popover-bg-color)]  rounded  z-10 flex flex-col"
    >
      <span className=" text-[length:--popover-heading-font-size] font-[var(--popover-heading-font-weight)] text-[var(--popover-heading-fg-color)] whitespace-nowrap cursor-pointer border-radius px-[8px] py-[12px]">
        FILTER BY
      </span>
      <hr className="border border-EAECF0" />
      <div className="px-5">
        <FilterRadioButtons
          name="order_sataus"
          label={"Order Status"}
          options={salesPurchaseStatusoptions}
          handleChange={handleOrderStatusChange}
          value={filterData?.orderStatus}
        />
      </div>
    </div>
  );
};

export default SalesPurchaseFilter;
